<div class="row pt-3">
  <attendance-panel-list-component
    class="col-xxl-3 col-lg-3 col-12 display-sidebar --list-expanded"
  />
  <attendance-panel-chat-component
    [ngClass]="
      isCollapsed
        ? 'col-xxl-9 col-lg-9 col-12'
        : 'col-xxl-6 col-lg-6 col-12 --chat-expanded'
    "
    (collapseEmitted)="isCollapsed = $event"
  />
  <attendance-panel-info-component
    id="attendance-contact-panel"
    class="col-xxl-3 col-lg-3 col-12 --sidebar-off-canvas"
  />
</div>
